const formatFilterQuery = (filter: string[] | string | number | undefined | null | boolean, name: string) => {
  if (Array.isArray(filter)) {
    if (!filter.length) return '';

    return filter
      .filter(Boolean)
      .map((filter) => `&${name}=${filter}`)
      .join('');
  } else if (filter !== undefined && filter !== null) {
    return filter ? `&${name}=${encodeURIComponent(filter)}` : '';
  } else {
    return '';
  }
};

export default formatFilterQuery;
